// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div h2 {
  padding: 0;
}
div h2::after {
  border-bottom: 0;
}
div > div {
  margin-top: 2rem;
}
div > div .select-perfil {
  display: flex;
  gap: 1rem;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/app/components/home/home.component.scss"],"names":[],"mappings":"AACI;EACI,UAAA;AAAR;AACQ;EACI,gBAAA;AACZ;AAEI;EACI,gBAAA;AAAR;AACQ;EACI,aAAA;EACA,SAAA;EACA,uBAAA;AACZ","sourcesContent":["div {\n    & h2 {\n        padding: 0;\n        &::after {\n            border-bottom: 0;\n        }\n    }\n    & > div {\n        margin-top: 2rem;\n        & .select-perfil {\n            display: flex;\n            gap: 1rem;\n            justify-content: center;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
